import Api from '../api/pay'
import store from '../store'
let tool = {
  trim (str) {
    return str.replace(/\s+/g, '')
  },
  getUrlParam (name) { // 封装方法
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
    let r = window.location.search.substr(1).match(reg) // 匹配目标参数
    if (r != null) return unescape(r[2])
    return null // 返回参数值
  },
  // 校验特殊字符
  validateName (newName) {
    var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
      regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im

    if (regEn.test(newName) || regCn.test(newName)) {
      return false
    }
  },
  ValidatePhone (val) {
    var isPhone = /^1(3|4|5|6|7|8|9)\d{9}$/// 手机号码
    var isMob = /^0?1[3|4|5|6|8][0-9]\d{8}$/// 座机格式
    if (isMob.test(val) || isPhone.test(val)) {
      return true
    } else {
      return false
    }
  },
  // 校验身份证
  ValidateCardId (val) {
    let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (reg.test(val) === false) {
      return false
    } else {
      return true
    }
  },
  getBLen (str) {
    if (str == null) return 0
    if (typeof str != 'string') {
      str += ''
    }
    return str.replace(/[^\x00-\xff]/g, '01').length
  },
  getStrLen (str) {
    var len = 0
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i)
      // 单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++
      } else {
        len += 2
      }
    }
    return len
  },
  dictCheck (arr, value) {
    let name = ''
    arr.forEach((item, index) => {
      if (item.key == value) {
        name = item.value
      }
    })
    return name
  },
  // 车牌号验证方法
  isVehicleNumber (vehicleNumber) {
    let xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
    let creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/
    if (vehicleNumber.length == 7) {
      return creg.test(vehicleNumber)
    } else if (vehicleNumber.length == 8) {
      return xreg.test(vehicleNumber)
    } else {
      return false
    }
  },
  // 校验车牌号码
  carNumber (rule, value, callback) {
    let param = value.trim()
    let isletter = /^[a-zA-Z]+$/.test(param)
    let isNum = /^[0-9]+$/.test(param)
    let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
    let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
    if (!isletter && !isNum) {
      if (regEn.test(param) || regCn.test(param)) {
        callback(new Error('请输入正确的车牌号码'))
      } else {
        if (param.length != 7 && param.length != 8) {
          callback(new Error('请输入正确的车牌号码'))
        } else {
          callback()
        }
      }
    } else {
      callback(new Error('请输入正确的车牌号码'))
    }
  },
  isEmailAddress (obj) {
    let pattern = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/
    let flag = pattern.test(obj)
    return flag
  },
  // 校验手机号码
  checkPhone (str) {
    if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(str))) {
      return false
    } else {
      return true
    }
  },
  isTel (str) {
    let reg = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/
    if (!reg.test(str)) {
      return false
    } else {
      return true
    }
  },
  // 2.利用sort排序
  sortArr (arr) {
    return arr.sort(function (a, b) {
      return a.endTimestamp - b.endTimestamp // 升序
    // return b - a; // 降序
    })
  },
  // 传入一个数组
  // 按照特定方式格式化,JavaScript 将数组中具有相同值的对象 取出组成新的数组
  sortSameNameArr (arr, str) {
    let _arr = [],
      _t = [],
      // 临时的变量
      _tmp
    let _arr2 = {}
    for (let i in arr) {
      if (_arr2[arr[i].cardId]){
        _arr2[arr[i].cardId].push(arr[i])
      } else {
        _arr2[arr[i].cardId] = [arr[i]]
      }
    }
    // 按照特定的参数将数组排序将具有相同值得排在一起
    arr = arr.sort((a, b) => {
      let s = a[str],
        t = b[str]
      return s < t ? -1 : 1
    })
    if (arr.length) {
      _tmp = arr[0][str]
    }
    // console.log( arr );
    // 将相同类别的对象添加到统一个数组
    for (let i in arr) {
      if (arr[i][str] === _tmp) {
        _t.push(arr[i])
      } else {
        _tmp = arr[i][str]
        _arr.push(_t)
        _t = [arr[i]]
      }
    }
    // 将最后的内容推出新数组
    _arr.push(_t)
    return _arr
  },
  // 校验金额
  money (value) {
    let money = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
    if (!money.test(value)) {
      return false
    } else {
      return true
    }
  },
  // 校验openId
  getWeixinCode (appType, callback) {
    let code
    if (appType == 'wx') {
      code = tool.getUrlParam('code')
    } else {
      code = tool.getUrlParam('auth_code')
    }
    if (!code) {
      let href = window.location.href
      let urlParams = href.split('#/')[1]
      let url = this.$config.Url + urlParams // 平云广场测试
      let redirectUri = encodeURIComponent(url)
      if (appType == 'wx') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +  this.$config.appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
      } else {
        window.location.href = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=' + this.$config.appid + '&scope=auth_base' + '&redirect_uri=' + redirectUri
      }
    } else {
      let param = {
        appid: this.$config.appid,
        code: code
      }
      // alert(auth_code)
      // alert(JSON.stringify(param))
      if (appType == 'wx') {
        Api.authorization(param).then(res => {
          let data = res.data
          let openId = data.openId
          store.commit('payParams/getOpenId', openId)
          store.commit('payParams/getPayParams', data)
          this.$wechat.config({
            debug: false,
            appId: appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr, // 随机串
            signature: data.signature,
            jsApiList: ['checkJsApi', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard',
              'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline','addCard','hideOptionMenu','hideMenuItems'
            ]
          })
          callback()
        }).catch(err => {
          console.log('err',err)
        })
      } else {
        Api.aliUserInfo(JSON.stringify(param)).then(res => {
          // alert(res.data.openId)
          // console.log("支付宝请求数据res",res)
          let data = res.data
          let openId = data.openId
          store.commit('payParams/getOpenId', openId)
          store.commit('payParams/getPayParams', data)
          callback()
        }).catch(err => {
          // alert(JSON.stringify(err))
          console.log('err',err)
        })
      }
    }
  }
}

export default tool



// WEBPACK FOOTER //
// ./src/tools/tool.js